import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CompanyDataResponse } from '../models/company-data.model';

import { ApiService } from './api.service';
import { TokenUpdateRequest } from './register.service';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  private readonly baseUrl = `${environment.externalGateServiceUrl}/integrations`;
  private apiService = inject(ApiService);


  fetchCompanyData(token: string): Observable<CompanyDataResponse> {
    return this.apiService.getExternal<CompanyDataResponse>(
      `${this.baseUrl}/company/validate/order/${token}`
    );
  }

  completeOrder(token: string, data: TokenUpdateRequest): Observable<unknown> {
    return this.apiService.putExternal<unknown>(
      `${this.baseUrl}/company/complete/order/${token}`,
      data
    );
  }
}